module.exports = __webpack_public_path__ + "static/media/ios-cloud-done.7c0ec8d8.svg";